import { Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function InfoStep01() {

  const { getValues } = useFormContext()
  const { step01 } = getValues()

  return (
    <>
      <Grid container spacing={2.5}>
        <TableView
          title="Conta lançamento"
          text={`${step01.conta_bancaria.codigo} - ${step01.conta_bancaria.nome}`}
        />
        <TableView
          title="Contra partida"
          text={`${step01.contra_partida.codigo_contabil} - ${step01.contra_partida.nome}`}
        />
        <TableView
          title="Data do lançamento"
          text={`${step01.data_lancamento?.format('DD/MM/YYYY')}`}
        />
        <TableView
          title="Valor"
          text={`${step01.valor}`}
        />
        <TableView
          title="D/C"
          text={`${step01.debito_credito}`}
        />
      </Grid>
    </>

  )
}

function TableView({ title, text }: TableViewProps) {
  return (
    <Grid size={{xs: 12, md: 6, lg: 4}}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Grid>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}